<template>
    <transition name="fade">
        <div class="modal-overlay" v-if="showModal">
            <div class="modal" :style="styles">
                <font-awesome-icon
                    v-if="closeable"
                    icon="times"
                    class="modal-close"
                    @click="this.closeModal"
                    :style="closeIconStyle"
                />
                <the-element
                    v-for="element in elements"
                    :element="element.element"
                    :type="element.element_type"
                    :key="element.id"
                    :interactionLayer="false"
                ></the-element>
            </div>
        </div>
    </transition>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex';
import theElement from '../elements/Element.vue';

export default {
    name: 'Modal',
    props: ['modal'],
    components: {
        theElement
    },

    mounted() {},

    computed: {
        ...mapGetters(['activeModalId', 'nodes']),

        closeIconStyle() {
            return {
                color: this.modal.close_icon_color
            };
        },

        elements() {
            return this.modal.elements;
        },

        showModal() {
            return this.modal.id === this.activeModalId;
        },

        styles() {
            let padding = (100 - this.modal.size) / 2 + '%';

            return {
                backgroundColor: this.modal.backgroundColour
                    ? this.modal.backgroundColour
                    : 'white',
                top: padding,
                bottom: padding,
                left: padding,
                right: padding,
                borderRadius: this.modal.border_radius + 'px'
            };
        },

        closeable() {
            return this.modal.show_close_icon;
        }
    },

    methods: {
        ...mapMutations(['closeModal', 'loadVideo']),
        loadDestinationNodesFromElements() {
            //     this.elements.forEach(el => {
            //         if (
            //             el.element &&
            //             el.element.action === 'playNode' &&
            //             el.element.actionArg
            //         ) {
            //             const node = this.nodes[el.element.actionArg.toString()];
            //             if (node) this.loadVideo(node.media_id);
            //         }
            //     });
        }
    }
};
</script>
<style>
.modal-overlay {
    background-color: rgba(0, 0, 0, 0.6);
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 3100;
}

.modal {
    position: absolute;
    /*top: 20px;*/
    /*left: 20px;*/
    /*right: 20px;*/
    /*bottom: 20px;*/
    /*border-radius: 5px;*/
    height: auto;
    width: auto;
}
.modal-close {
    position: absolute;
    right: 10px;
    top: 10px;
    color: #113348;
    font-size: 16px;
    cursor: pointer;
    z-index: 501;
}
</style>
